import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-edit-btn",
  templateUrl: "./edit-btn.component.html",
  styleUrls: ["./edit-btn.component.scss"],
})
export class EditBtnComponent {
  @Input() disabledFlag: boolean = false;
  @Output() actionBtnCallback = new EventEmitter<any>();

  btnAction() {
    this.actionBtnCallback.emit();
  }
}
